export default {
  env: {
    localhost: 'dev',
    'arl-online-tax-qa5-blue.addevcloudsites.myob.com': 'qa5',
    'lodge.myob.com': 'prod'
  },
  authUri: {
    dev: 'https://test.secure.myob.com',
    qa5: 'https://test.secure.myob.com',
    prod: 'https://secure.myob.com'
  },
  clientId: {
    dev: 'nz-tax-team',
    qa5: 'nz-tax-team',
    prod: 'fawxac6atk56cxs2mny89s8n'
  },
  redirectUri: {
    dev: 'http://localhost:4040',
    qa5: 'https://arl-online-tax-qa5-blue.addevcloudsites.myob.com',
    prod: 'https://lodge.myob.com'
  },
  publicApiUri: {
    dev: 'http://localhost:3010',
    qa5: 'https://sme-api-online-tax-qa5-blue.addevcloudsites.myob.com',
    prod: 'https://sme-api-online-tax.partner.myob.com'
  },
  smeDashboardUri: {
    dev: 'http://localhost:4001',
    qa5: 'https://forms-online-tax-qa5-blue.addevcloudsites.myob.com',
    prod: 'https://forms-online-tax.partner.myob.com'
  }
}



// WEBPACK FOOTER //
// ./src/app/config.js